import { FormControl, Select, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import { setProfileCompilationFilter } from "../containers/app-container/reducer/filterSlice";
import { STATUS_LABEL, STATUS_DESCRIPTION } from "../utils/memberStatus";

// Account Status filter — the SAME seven buckets every other screen names, plus the derived
// Active total. Until 2026-09-24 this was a "Profile Level" dropdown mixing two completion
// bands (0-49, 50-99) with three status buckets, so the same member could be called one thing
// here and another on the status column beside it. The bands are gone: Ghost now means
// "never finished signup", which is what they were mostly measuring, and the Signup Report's
// drop-off answers "how far did they get" properly.
//
// The VALUES are the canonical bucket keys, the same vocabulary `?status=` uses — one
// filtering language across the admin. filterMiddleware's profileMap maps each to
// canonBucketConds(), and still accepts the old completed/hiddenByAdmin values.
//
// `deleted` is deliberately NOT here: those members are not in the `users` collection this
// filter queries, so no predicate can return them. They are reached through the Deleted
// Accounts screen, or the attribution tree's Deleted cell, which swaps to the delete-log list.
const OPTIONS = [
  { value: "active", color: "#2e7d32" },
  { value: "approved", color: "#2e7d32" },
  { value: "hidden", color: "#e58209" },
  { value: "inactive", color: "#d32f2f" },
  { value: "ghost", color: "#6b7280" },
  { value: "deactivated", color: "#d32f2f" },
  { value: "suspended", color: "#d32f2f" },
];

export default function ProfileCompilationDropdown() {
  const selected = useSelector((state) => state.filter.profileCompilation) ?? "";
  const dispatch = useDispatch();

  const colorOf = (v) => OPTIONS.find((o) => o.value === v)?.color || "#999";

  return (
    <FormControl
      size="small"
      sx={{
        minWidth: 120,
        boxShadow: 'none',
        '& .MuiOutlinedInput-root': {
          borderRadius: '6px',
          background: '#f3f4f6',
          boxShadow: 'none',
          '& fieldset': {
            borderColor: '#d1d5db',
            borderWidth: '1px',
          },
          '&:hover fieldset': {
            borderColor: '#9ca3af',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#2563eb',
            borderWidth: '1.5px',
          },
        },
      }}
    >
      <Select
        value={selected}
        displayEmpty
        onChange={(e) => dispatch(setProfileCompilationFilter({ profileCompilation: e.target.value }))}
        IconComponent={KeyboardArrowDownIcon}
        sx={{
          borderRadius: "8px",
          fontSize: "14px",
          color: colorOf(selected),
          "& .MuiSelect-select": { padding: "10px 14px" },
          "& .MuiSelect-displayEmpty": { color: "#999" },
          "& .MuiSvgIcon-root": { color: "#747474ff", fontSize: "22px" },
        }}
      >
        <MenuItem value="" sx={{ fontSize: "14px", color: "#666" }}>
          <em>All Statuses</em>
        </MenuItem>
        {OPTIONS.map((o) => (
          <MenuItem
            key={o.value}
            value={o.value}
            title={STATUS_DESCRIPTION[o.value]}
            sx={{ fontSize: "14px", color: o.color, fontWeight: 500 }}
          >
            {STATUS_LABEL[o.value]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
